// extracted by mini-css-extract-plugin
export var amount = "styles-module--amount--825a9";
export var button = "styles-module--button--1092a";
export var buttonBordered = "styles-module--button-bordered--081b3";
export var groupHeading = "styles-module--group-heading--1a781";
export var groupTr = "styles-module--group-tr--231b6";
export var last = "styles-module--last--5e73f";
export var pricing = "styles-module--pricing--9d06a";
export var pricingRangeWrapper = "styles-module--pricing-range-wrapper--148f7";
export var range = "styles-module--range--6e4ce";
export var slider = "styles-module--slider--aea12";
export var spacer = "styles-module--spacer--c0af4";
export var switchWrapper = "styles-module--switch-wrapper--2debd";
export var switcher = "styles-module--switcher--5beb0";
export var table = "styles-module--table--83724";
export var tableWrapper = "styles-module--table-wrapper--38b95";
export var tbody = "styles-module--tbody--a1e50";
export var td = "styles-module--td--54b31";
export var th = "styles-module--th--aaac8";
export var thead = "styles-module--thead--cfb8d";
export var themeGreen = "styles-module--theme-green--3a1f0";
export var themePink = "styles-module--theme-pink--ee9f9";
export var tr = "styles-module--tr--ba6bf";
export var type = "styles-module--type--a792d";
export var unit = "styles-module--unit--33b45";